var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('router-link',{attrs:{"to":"/anshu"}},[_vm._v("桉树")]),_c('router-link',{attrs:{"to":"/bbc"}},[_vm._v("BCC")]),_c('router-link',{attrs:{"to":"/xingyuan"}},[_vm._v("兴源认证")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }